export default function Finance(){return <div className='p-8'>Finance</div>}